import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { Package, PackageHost } from '../../Container';
import { inSpotlightCommands } from './SpotlightCommands';
import { SpotlightMechanics } from './SpotlightMechanics';
import { SpotlightOverlay } from './SpotlightOverlay';
import { AutoSpotlightInfo, ManualSpotlightInfo } from './SpotlightProperties';

export class SpotlightPackage implements Package {

    public install = (host: PackageHost) => host
        .register(SpotlightMechanics, 'singleton')
        .register(SpotlightOverlay, 'singleton')
        .plug(inSessionProperties(StateProperty.variable(AutoSpotlightInfo, AutoSpotlightInfo.empty)))
        .plug(inSessionProperties(StateProperty.variable(ManualSpotlightInfo, ManualSpotlightInfo.empty)))
        .plug(inSpotlightCommands())
        // .plug(inTool(spotlightTool))
        .start(SpotlightMechanics, SpotlightOverlay)
        ;
}
